import React from "react";
import PageTitle from "sc/ui/sites/oncall/components/PageTitle";
import { Row, Col, Panel } from "react-bootstrap";
import { connect } from "react-redux";
import { region } from "../../../selectors/regions";
import { regionPageLoad, regionAddRequest } from "../../../actions/regions";
import { push } from "react-router-redux";
import RegionForm from "../../../components/forms/Region";
import componentWithLoadTrigger from "sc/ui/components/hoc/componentWithLoadTrigger";

export default connect(
  (state, ownProps) => ({
    region: region(state),
  }),
  (dispatch, ownProps) => ({
    onLoad: () => dispatch(regionPageLoad()),
    onSave: formData => dispatch(regionAddRequest(formData)),
    onRegionList: () => dispatch(push("/regions")),
  }),
)(
  componentWithLoadTrigger(props => {
    if (props.region === null) return <div />;
    return (
      <div id="add-region-page">
        <PageTitle title="Create Region" />
        <div>
          <a
            id="back"
            style={{ cursor: "pointer" }}
            onClick={props.onRegionList}
          >
            <span className="glyphicon  glyphicon-circle-arrow-left" />
            Back to regions list
          </a>
        </div>
        <br />
        <Panel bsStyle="info">
          <Panel.Heading>
            <Panel.Title componentClass="h3">Region data</Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <Row>
              <Col md={8} mdOffset={2}>
                <RegionForm
                  region={props.region}
                  onSave={props.onSave}
                  disabled={props.region.generalDataSaveInProgress}
                  backendError={props.region.generalDataError}
                />
              </Col>
            </Row>
          </Panel.Body>
        </Panel>
      </div>
    );
  }),
);



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/pages/partner-admin/regions/Add.js